import { toByteArray as toByteArray_1 } from '../../node_modules/base64-js/index.js';

function ToPixelList(json) {
    if (json) {
        return {
            sources: json.sources.map(ToSources),
            executions: json.executions.map(ToExecutions),
        };
    }
    return undefined;
}
const base64ToString = (data) => {
    return new TextDecoder().decode(toByteArray_1(data));
};
function ToSources(source) {
    if (source) {
        return {
            id: source['id'],
            code: source['code'] && base64ToString(source['code']),
        };
    }
    return undefined;
}
function ToExecutions(execution) {
    if (execution) {
        return {
            pixel: base64ToString(execution['pixel']),
        };
    }
    return undefined;
}

export { ToExecutions, ToPixelList, ToSources };
//# sourceMappingURL=PixelList.js.map
